module.exports = __webpack_public_path__ + "img/chart1.ef731f48.png";